import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import {NavigationOptions} from '../elements.types'



@Component({
  selector: 'as-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['../../../common/styles/navigation.scss']
})

export class NavigationComponent implements OnInit {
  @Input() title: string;
  @Input() items: Array<NavigationOptions>

  constructor( private _route: ActivatedRoute) { }

  ngOnInit() {
    this._route.url.subscribe(params => {
      //
    });
  }

}
